import React from 'react'
import AboutInfo from '../components/AboutInfo'

function About() {
  return (
    <AboutInfo/>
  )
}

export default About